import React from 'react';
import {createMaterialTopTabNavigator} from '@react-navigation/material-top-tabs';
import {BaseScreen, TabBar} from 'src/design-system';
import Claims from 'src/modules/billing/components/claims';
import Payers from 'src/modules/billing/components/payers';
import ManagedBillingPromo from 'src/modules/billing/components/managed-billing-promo';
import {withDatabase} from '@nozbe/watermelondb/react';
import {withObservables} from '@nozbe/watermelondb/react';
import withState from 'src/redux/wrapper';
import {compose} from 'recompose';
import {of} from 'rxjs';
import {useRoute} from '@react-navigation/native';
import {Q} from '@nozbe/watermelondb';
import {mergeMap} from 'rxjs';

const Navigator = createMaterialTopTabNavigator();

const BillingScreen = ({role, instance, profile}: any) => {
  const route = useRoute();
  return (
    <BaseScreen header={false}>
      <TabBar navigator={Navigator} location={'Billing'} route={route}>
        {role?.billingClaimView && instance?.billing ? (
          <Navigator.Screen name="Claims">
            {() => <Claims role={role} profile={profile} />}
          </Navigator.Screen>
        ) : (
          <></>
        )}
        {!instance?.billing ? (
          <Navigator.Screen name="Managed Billing">
            {() => <ManagedBillingPromo />}
          </Navigator.Screen>
        ) : (
          <></>
        )}
        {role?.billingPayerView ? (
          <Navigator.Screen name="Payers">
            {() => <Payers role={role} />}
          </Navigator.Screen>
        ) : (
          <></>
        )}
        {/* {role?.billingPayerView ? ( */}
        {/* <Navigator.Screen name="Remits">{() => <Remits />}</Navigator.Screen> */}
        {/* ) : (
          <></>
        )} */}
      </TabBar>
    </BaseScreen>
  );
};

export default compose(
  withDatabase,
  withState,
  withObservables(['authentication'], ({database, authentication}: any) => {
    return {
      profile: authentication?.userId
        ? database.get('users').findAndObserve(authentication.userId)
        : of(),
      instance: database
        ?.get('instances')
        .query(Q.where('_partition', authentication.selectedGroup))
        .observe()
        .pipe(mergeMap(x => x)),
    };
  }),
  withObservables([], ({profile}: any) => {
    return {
      role: profile.role,
    };
  }),
)(BillingScreen);
